export default __webpack_public_path__ + "static/media/unknown.53e8d8da.svg";